import routes from 'defs/routes';

/*
 * DataBags are data payloads which are used by one or multiple views.
 * Each data bag defines a set of data.
 */
const DATA_BAG = {
	DASHBOARD: 'dataBagDashboard',
	TODAY_FEED_VIEW: 'dataBagTodayFeedView',
	TODAY_SELECTED_VIEW: 'dataBagTodayFeedViewSelected_{day}',
	MY_SUCCESS: 'dataBagMySuccess',
	MY_SUCCESS_LEVELS: 'dataBagMySuccessLevels',
	PROFILE: 'dataBagProfile',
	FAVORITES: 'dataBagFavorites',
	FAVORITE_CLUSTER: 'dataBagFavoriteCluster_{type}',
	PROGRAMS: 'dataBagPrograms',
	PROGRAM_PREVIEW: 'dataBagProgramPreview_{id}',
	CALENDAR: 'dataBagCalendar',
	CALENDAR_TODAY: 'dataBagCalendarToday',
	POOL: 'dataBagPool_{id}',
};

export type DataBagValueType = string;
export type DataBagKeyType = keyof typeof DATA_BAG;

/*
 * Certain data bags can be dynamic (e.g. program preview).
 * Those are declared here to enable templating the data-bag-key in runtime.
 */
const DYNAMIC_DATA_BAGS: DataBagValueType[] = [
	DATA_BAG.TODAY_SELECTED_VIEW,
	DATA_BAG.FAVORITE_CLUSTER,
	DATA_BAG.PROGRAM_PREVIEW,
	DATA_BAG.POOL,
];

/*
 * Map certain DataBag definitions to routes,
 * which are processed in the HOC.
 */
const VIEW_REQUIRES_DATA_BAG_MAP: {
	[route: string]: DataBagValueType[];
} = {
	[routes.dashboard.indexRoute.id]: [DATA_BAG.DASHBOARD],
	[routes.today.indexRoute.id]: [DATA_BAG.TODAY_FEED_VIEW],
	[routes.today.day.id]: [DATA_BAG.TODAY_SELECTED_VIEW],
	[routes.mySuccess.indexRoute.id]: [DATA_BAG.MY_SUCCESS],
	[routes.profile.indexRoute.id]: [DATA_BAG.PROFILE],
	[routes.favorites.indexRoute.id]: [DATA_BAG.FAVORITES],
	[routes.favorites.cluster.id]: [DATA_BAG.FAVORITE_CLUSTER],
	[routes.program.further.id]: [DATA_BAG.PROGRAMS],
	[routes.program.recommended.id]: [DATA_BAG.PROGRAMS],
	[routes.program.preview.id]: [DATA_BAG.PROGRAM_PREVIEW],
	[routes.pool.indexRoute.id]: [DATA_BAG.POOL],
};

/*
 * Payload mapping for view rendering, extract
 * keys from the URL of the page (history match)
 */
const VIEW_MAP_PAYLOAD_EXTRACTOR: {
	[key: string]: string[];
} = {
	[routes.program.preview.id]: ['id'],
	[routes.today.day.id]: ['day'],
	[routes.pool.indexRoute.id]: ['selectedPool'],
};

/*
 * The following views need an internet connection to work.
 */
const VIEW_REQUIRES_ONLINE: string[] = [
	routes.anamnesis.indexRoute.id,
	routes.anamnesis.start.id,
	routes.anamnesis.selectCoach.id,
	routes.anamnesis.selectGender.id,
	routes.anamnesis.determineAge.id,
	routes.anamnesis.determineHeight.id,
	routes.anamnesis.determineWeight.id,
	routes.anamnesis.defineHealthTarget.id,
	routes.anamnesis.acceptHealthTarget.id,
	routes.anamnesis.selectActivityLevel.id,
	routes.anamnesis.verify.id,
	routes.anamnesis.disclaimer.id,
	routes.anamnesis.dsgvo.id,
	routes.favorites.detail.id,
	routes.deepLink.startProgram.id,
];

/*
 * Views which always be available
 */
const VIEW_ALWAYS_AVAILABLE: Array<string> = [routes.login.indexRoute.id];

export {
	DATA_BAG,
	DYNAMIC_DATA_BAGS,
	VIEW_REQUIRES_DATA_BAG_MAP,
	VIEW_REQUIRES_ONLINE,
	VIEW_ALWAYS_AVAILABLE,
	VIEW_MAP_PAYLOAD_EXTRACTOR,
};
